import { autoinject } from "aurelia-dependency-injection";
import { ImportView } from "./views/Import";
import { ImportModel } from "./models/Import";
import { MasterView } from "../shared/views/master-view";
import { AppEvents } from "../app-events";
import {TemplateManager} from "../shared/helpers/template-manager";
// require("./Import.less");

@autoinject
export class ImportModule extends Backbone.Model {

    private importRegion: Marionette.Region;

    constructor(
        private appEvents: Backbone.Events,
        private importView: ImportView,
        public importModel: ImportModel,
        private templateManager: TemplateManager,
        private masterView: MasterView) {
        super();
        this.setupViews();
    }
    public show(dataSource: string): void {
        $("#viewport-content").addClass("import-status");
        this.importModel.load(dataSource);
        this.importRegion.show(this.importView);

    }

    public hide(): void {
        $("#viewport-content").removeClass("import-status");
        //  (<any>this.importRegion).$el.addClass('vanish').fadeOut();
    }

    public reset(): void {
        this.importRegion.empty({preventDestroy: true});
    }

    private setupViews(): void {
        this.listenToOnce(this.masterView, "render", () => {
            this.importRegion = this.masterView.addRegion("importRegion", "#import-status-region");
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/import-module.ts